import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Contract from '../views/constracts/index.vue'
import Payment from '../views/Payment.vue'
import Dashboard from '../views/Dashboard.vue'
import ContractDetail from '../views/constracts/detail.vue'
import Profile from '../views/Profile.vue'
import Password from '../views/Password.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/lookups/:name',
    name: 'lookups',
    component: () => import('../views/lookups/base/index.vue')
  },
  {
    path: '/:name',
    name: 'contracts',
    component: Contract
  },
  {
    path: '/:name',
    name: 'contracts',
    component: Contract
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment
  },
  {
    path: '/:name/:id',
    name: 'contracts-detail',
    component: ContractDetail
  },
  {
    path: '/',
    name: 'home',
    component: Dashboard
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/users/index.vue')
  },
  {
    path: '/users/:id',
    name: 'users-detail',
    component: () => import('../views/users/detail.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/password',
    name: 'password',
    component: Password
  },
  {
    path: '/treatment',
    name: 'treatment',
    component: () => import('../views/lookups/Treatment.vue')
  },
  {
    path: '/amount',
    name: 'amount',
    component: () => import('../views/lookups/PaymentAmount.vue')
  },
  {
    path: '/sms',
    name: 'sms',
    component: () => import('../views/sms/index.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// router.beforeEach((to, from, next) => {
//   // console.log(to, 'dddd')
//   // if (to.hash !== '#login') {
//   //   next({ path: '/about', hash: '#login' })
//   // } else {
//   //   next()
//   // }
//   return true
// })
export default router
